import React, { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Outlet, Navigate } from 'react-router-dom'
import { resetAlfredTour } from '@/lib/alfred-tour'

export const SecureRoute: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth()

  useEffect(() => {
    if (!authState) return

    if (!authState.isAuthenticated) {
      resetAlfredTour()
      // Store the URL the user WAS trying to go to (so we can send them back there later)
      const originalUri = toRelativeUrl(window.location.href, window.location.origin)
      oktaAuth.setOriginalUri(originalUri)
    }
  }, [oktaAuth, authState])

  if (!authState) {
    return <div>Loading...</div>
  }

  // If not logged in, send them to /login route
  if (!authState.isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
